import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {FORM_FIELD_ELEMENT_NAME_MAX, FORM_TITLE_MAX, FORM_TITLE_MIN, TEXT_INPUT_REGEX_MAX, TEXT_INPUT_REGEX_MESSAGE_MAX} from './constant';

// Define a schema for fieldElements objects
export const fieldElementSchema = z.object({
    type: z.string(),
    htmlName: z
        .string()
        .min(1, `fieldName;min;1`)
        .max(FORM_FIELD_ELEMENT_NAME_MAX, `fieldName;max;${FORM_FIELD_ELEMENT_NAME_MAX}`)
        .optional(),
    label: z
        .string()
        .max(FORM_FIELD_ELEMENT_NAME_MAX, `label;max;${FORM_FIELD_ELEMENT_NAME_MAX}`)
        .min(1, 'designSidepanel.tooShortFieldLabel')
        .optional(),
    placeholder: z
        .string()
        .max(FORM_FIELD_ELEMENT_NAME_MAX, `placeholder;max;${FORM_FIELD_ELEMENT_NAME_MAX}`)
        .min(1, 'designSidepanel.tooShortFieldPlaceholder')
        .optional(),
    text: z
        .string()
        .max(FORM_FIELD_ELEMENT_NAME_MAX, `text;max;${FORM_FIELD_ELEMENT_NAME_MAX}`)
        .min(1, 'designSidepanel.tooShortFieldLabel')
        .optional(),
    validationType: z.string().optional(),
    regex: z.string().max(TEXT_INPUT_REGEX_MAX, `regex;max;${TEXT_INPUT_REGEX_MAX}`).optional(),
    regexErrorMessage: z.string().max(TEXT_INPUT_REGEX_MESSAGE_MAX, `regexErrorMessage;max;${TEXT_INPUT_REGEX_MESSAGE_MAX}`).optional(),
});

export const formValidator = z.object({
    type: z.literal(ELEMENT.FORM),
    title: z.string().min(FORM_TITLE_MIN, 'designSidepanel.tooShortFormTitle').max(FORM_TITLE_MAX, 'designSidepanel.tooLongFormTitle'),
    fieldElements: z
        .array(fieldElementSchema)
        .refine((fieldElements) => fieldElements.some((element) => element.type === ELEMENT.TEXT_INPUT), {
            message: 'designSidepanel.textsInputRequired',
        }),
});
